// @flow

import React from 'react';

import { translate } from '../../../base/i18n';
import Message from '../../../base/react/components/web/Message';
import { connect } from '../../../base/redux';
import { MESSAGE_TYPE_LOCAL } from '../../constants';
import AbstractChatMessage, { type Props } from '../AbstractChatMessage';

import PrivateMessageButton from './PrivateMessageButton';

/**
 * Renders a single chat message.
 */
class ChatMessage extends AbstractChatMessage<Props> {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { message, t, knocking } = this.props;
        return (
        <>
            {/* className = 'chatmessage-wrapper'
            id = { this.props.message.messageId } */}
        <div
            className='chatmessage-wrapper'>
            <div
                // tabIndex = {0}
                // aria-hidden={true}
                 className = { `chatmessage ${message.privateMessage ? 'privatemessage' : ''} ${
                    message.lobbyChat && !knocking ? 'lobbymessage' : ''}` }>
                 <div className = 'replywrapper'>
                    <div className = 'messagecontent'>
                        {/* { this.props.showDisplayName && this._renderDisplayName() } */}
                        <div className = 'usermessage'>
                            <Message text = { this._getMessageText() } />
                        </div>
                        { (message.privateMessage || (message.lobbyChat && !knocking))
                            && this._renderPrivateNotice() }
                    </div>
                    { (message.privateMessage || (message.lobbyChat && !knocking))
                        && message.messageType !== MESSAGE_TYPE_LOCAL
                        && (
                            <div
                                className = { `messageactions ${
                                    message.lobbyChat ? 'lobbychatmessageactions' : ''}` }>
                                <PrivateMessageButton
                                    isLobbyMessage = { message.lobbyChat }
                                    participantID = { message.id }
                                    reply = { true }
                                    showLabel = { false } />
                            </div>
                        ) }
                 </div>
            </div>
        </div>
            <span tabIndex={-1} >{ this.props.showTimestamp && this._renderTimestamp() }</span>

        </>
        );
    }

    _getFormattedTimestamp: () => string;

    _getMessageText: () => string;

    _getPrivateNoticeMessage: () => string;

    /**
     * Renders the display name of the sender.
     *
     * @returns {React$Element<*>}
     */
    // _renderDisplayName() {
    //     return (
    //         <div

    //         </div>
    //     ); -- Moved the base code in side another function namely _renderTimestamp
    // }

    /**
     * Renders the message privacy notice.
     *
     * @returns {React$Element<*>}
     */
    _renderPrivateNotice() {
        return (
            <div className = 'privatemessagenotice'>
                { this._getPrivateNoticeMessage() }
            </div>
        );
    }

    /**
     * Renders the time at which the message was sent.
     *
     * @returns {React$Element<*>}
     */
    _renderTimestamp() {
        const { message, t, knocking } = this.props;
        return (
            <div className = 'timestamp' tabIndex={0} aria-hidden={true}>
                  { this.props.message.displayName === this.props.message.recipient
                    ? t('chat.messageAccessibleTitleMe')
                    : this.props.message.displayName} { this._getFormattedTimestamp() }

            </div>
        )
    }
}

/**
 * Maps part of the Redux store to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @returns {Props}
 */
function _mapStateToProps(state: Object): $Shape<Props> {
    const { knocking } = state['features/lobby'];

    return {
        knocking
    };
}

export default translate(connect(_mapStateToProps)(ChatMessage));
